import { Prerequisite, PrerequisiteLoadingService } from "./loading/prerequisite-loading-service";
import { PreferenceService } from "./preferenceSvc";

export let darkTheme: DisplayTheme = "Dark";
export let lightTheme: DisplayTheme = "Light";

export type DisplayTheme = "Dark" | "Light";

export interface DisplayThemeService {
  /** gets the current display theme as an enum ServiceDesk.Services.DisplayTheme */
  getCurrentDisplayTheme(): DisplayTheme;
}

export class DisplayThemeServiceImpl implements DisplayThemeService {
  private currentDisplayTheme: DisplayTheme;

  // @ngInject
  constructor(private preferenceService: PreferenceService, private $q: ng.IQService) {}

  public getCurrentDisplayTheme(): DisplayTheme {
    return this.currentDisplayTheme;
  }

  public getThemePromise(): ng.IPromise<string> {
    return this.preferenceService.getPreference("ServiceDesk").then(
      (preference: any) => {
        if (preference && preference.content["displayTheme"]) {
          return preference.content["displayTheme"];
        } else {
          return lightTheme;
        }
      },
      () => {
        return lightTheme;
      }
    );
  }

  public prerequisiteLoadCallback(prerequisite: Prerequisite) {
    if (!prerequisite.displayTheme) {
      return this.$q.resolve();
    }
    if (
      !angular.isArray(prerequisite.displayTheme) ||
      prerequisite.displayTheme.find((bool: boolean) => {
        return typeof bool != "boolean";
      })
    ) {
      throw Error(`malformed prerequisite for displayTheme. ${prerequisite}`);
    }
    if (prerequisite.displayTheme.includes(true)) {
      return this.getThemePromise().then((theme: DisplayTheme) => {
        this.currentDisplayTheme = theme;
      });
    }
    return this.$q.resolve();
  }
}
